import React, { HTMLAttributes } from "react";
import classNames from "classnames";

// Card wraps card-like components, acting as a basic building block

interface Props extends HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  className?: string;
  elevated?: boolean;
}

const Card: React.FC<Props> = ({
  children,
  elevated = true,
  className,
  ...props
}) => {
  return (
    <div
      className={classNames("rounded p-md", className, {
        "shadow-low": elevated,
      })}
      {...props}
    >
      {children}
    </div>
  );
};

export default Card;
